import { useGoalToast } from '@/hooks/useGoalToast';

export function GoalToastProvider() {
  useGoalToast();
  return null;
}